// FILE: src/theme/tokens.js
// Design tokens (plan WP-8, owner-approved 2026-10-07). Every pair used for
// text is WCAG AA or better; the ratios are recorded next to each value and
// checked by UI-A11Y-03. Change a value here, nowhere else.
export const tokens = {
  light: {
    primary: "#1E5B3A", // white text 8.0:1; on page 7.5:1
    primaryHover: "#174A2F",
    onPrimary: "#FFFFFF",
    primaryTint: "#E7F1EB", // selected / current; primary text on it 7.0:1
    page: "#F5F8F6",
    surface: "#FFFFFF",
    surfaceRaised: "#FFFFFF",
    text: "#16211B", // 16.6:1 on surface
    textSecondary: "#4B5B52", // 7.2:1 on surface, 6.7:1 on page
    inputBorder: "#7F9187", // non-text 3.3:1 (WCAG 1.4.11)
    divider: "#E1E8E3",
    error: "#B3261E",
    errorTint: "#FBEAE9", // error text on it 5.6:1
    warning: "#8A5300",
    warningTint: "#FDF1DD", // 5.7:1
    info: "#1D5A86",
    infoTint: "#E8F1F8", // 6.4:1
    focus: "#1D5A86",
    // Google Maps text attribution: Google allows only #5E5E5E, #1F1F1F or
    // white (≥ 4.5:1). 6.4:1 on surface.
    googleAttribution: "#5E5E5E"
  },
  dark: {
    primary: "#6CC495", // text #0E1511 on it 8.8:1
    primaryHover: "#86D3A9",
    onPrimary: "#0E1511",
    primaryTint: "#1B3326", // primary text on it 6.4:1
    page: "#0E1511",
    surface: "#151F19",
    surfaceRaised: "#1A251F",
    text: "#E7EEE9",
    textSecondary: "#A9B8AF", // 8.2:1 on surface
    inputBorder: "#5B6E63", // non-text 3.1:1
    divider: "#26332B",
    error: "#F2867E",
    errorTint: "#3A1A18", // 6.3:1
    warning: "#E8B35A",
    warningTint: "#3A2C12", // 7.1:1
    info: "#7DB8E8",
    infoTint: "#15232F", // 7.5:1
    focus: "#7DB8E8",
    googleAttribution: "#FFFFFF" // 16:1 on surface
  }
};

export const FONT_STACK =
  '"Inter Variable", Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

// MTO 5.1: text ≥ 12 pt. 12 pt = 16 px = 1rem at the default browser size,
// so nothing in the app is set smaller than 1rem.
export const MIN_FONT_REM = 1;
